import { Flex, Tabs, Text } from '@applyboard/crystal-ui';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PageHeader } from '~/components/PageHeader';

const TABS = [
  { index: '1', path: '/conversion-rules/course-mappings', label: 'Course Mappings' },
  { index: '2', path: '/conversion-rules/grade-conversions', label: 'Grade Conversions' },
];

export function DesktopLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedTab = TABS.find((tab) => location.pathname.includes(tab.path))?.index || '1';

  const onTabChange = (tabIndex: string) => {
    const tab = TABS.find((t) => t.index === tabIndex);
    if (tab) {
      navigate(tab.path);
    }
  };

  return (
    <Flex p={10} gap={8} direction="column">
      <Flex direction="column">
        <PageHeader title="Conversion Rules" />
        <Text variant="labelL" contrast="low">
          Manage the grade conversion rules for your institution.
        </Text>
      </Flex>
      <Tabs
        align="left"
        aria-label="Conversion Rules Navigation"
        emphasis="highlighted"
        onChange={onTabChange}
        orientation="horizontal"
        value={selectedTab}
      >
        <Tabs.Item label="Course Mappings" value="1">
          <Outlet />
        </Tabs.Item>
        <Tabs.Item label="Grade Conversions" value="2">
          <Outlet />
        </Tabs.Item>
      </Tabs>
    </Flex>
  );
}
